import { Divider, Flex } from '@shared/components';

import { OverviewSectionFormField } from '../overview-section-form-field';
import { QuestionBlueprintSectionFormField } from '../question-blueprint-section-form-field';
export default function BasicSettingFormField() {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: (theme) => theme.spacing(6),
      }}
    >
      <OverviewSectionFormField />
      <Divider />
      <QuestionBlueprintSectionFormField />
    </Flex>
  );
}
